import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreRoutingModule } from './core-routing.module';
import { ApiService } from './services/api.service';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthGuardService } from './services/auth-guard.service';
import { LoginComponent } from './login/login.component';
import { HeaderComponent } from './header/header.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { AuthenticationService } from './services/authentication.service';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { SharedModule } from '../shared/shared.module';
import { AlertService } from '../shared/services/alert.service';
import { FlashMessageComponent } from '../shared/components/flash-message/flash-message.component';
import { RegisterComponent } from './register/register.component';
import { IdentiteService } from '../identite/shared/services/identite.service';
import { JwtInterceptorService } from './services/jwt-interceptor.service';
import { ErrorInterceptorService } from './services/error-interceptor.service';
import { ReactiveFormsModule } from '@angular/forms';
import { LanguageService } from './services/language.service';
import { EventService } from '../shared/services/event.service';
import { StorageService } from '../shared/services/storage.service';
import { FooterComponent } from './footer/footer.component';
import { NotifyMessageComponent } from '../shared/components/notify-message/notify-message.component';
import { AgenceService } from '../agence/shared/services/agence.service';
import { WINDOW_PROVIDERS } from './shared/providers/window';
import { AclGuardService } from './services/acl-guard.service';
import { AclResolver } from './shared/resolver/acl.resolver';
import { NgHttpLoaderModule } from "ng-http-loader";
import { MsalService } from '@azure/msal-angular';
import { Z16ProModule } from "../z16pro/z16pro.module";
import { TauxTvaService } from './services/taux-tva.service';
import { CacheInterceptor } from './services/cache-interceptor.service';
import { ConfigurationService } from '../configuration/shared/services/configuration.service';
import { PasswordOublieComponent } from './password-oublie/password-oublie.component';
import { ConfigurationClientService } from './services/configuration-client.service';
import { ValidationFacturesComponent } from './validation-factures/validation-factures.component';
import { FactureFournisseurService } from '../facturation/shared/services/facture-fournisseur.service';


@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        CoreRoutingModule,
        ReactiveFormsModule,
        NgHttpLoaderModule,
        Z16ProModule,
    ],
    exports: [
        RouterModule,
        HeaderComponent,
        FooterComponent,
        FlashMessageComponent,
        NotifyMessageComponent
    ],
    declarations: [
        LoginComponent,
        RegisterComponent,
        HeaderComponent,
        BreadcrumbComponent,
        NotFoundComponent,
        FlashMessageComponent,
        NotifyMessageComponent,
        FooterComponent,
        PasswordOublieComponent,
        ValidationFacturesComponent
    ],
    providers: [
        WINDOW_PROVIDERS,
        TauxTvaService,
        ApiService,
        AlertService,
        EventService,
        StorageService,
        AuthenticationService,
        IdentiteService,
        AuthGuardService,
        AclGuardService,
        LanguageService,
        AgenceService,
        { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptorService, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptorService, multi: true },
        AclResolver,
        MsalService,
        ConfigurationService,
        ConfigurationClientService,
        FactureFournisseurService
    ],
})
export class CoreModule { }
